export default "__VITE_ASSET__B6bG4ZOV__"